import { useState, useRef, useEffect } from 'react';

const testimonials = [
  { name: 'Mike & Sarah T.', location: 'Elkhart, IN', service: 'Hardscape Patio', rating: 5, text: 'Valley View transformed our backyard completely. The flagstone patio they built is absolutely stunning and the craftsmanship is second to none. We get compliments every time someone visits. Highly recommend for any stone or construction project!' },
  { name: 'James R.', location: 'Goshen, IN', service: 'Outdoor Kitchen', rating: 5, text: 'They built us a dream outdoor kitchen with natural stone countertops and a built-in grill. The attention to detail was incredible — every stone was hand-placed perfectly. The crew was professional, clean, and finished on time.' },
  { name: 'Patricia M.', location: 'South Bend, IN', service: 'Retaining Wall', rating: 5, text: 'Had a serious erosion problem on a slope in our yard. Valley View designed and built a beautiful tiered stone retaining wall that completely solved it. Two years later it still looks perfect. Worth every penny.' },
  { name: 'David & Carol L.', location: 'Mishawaka, IN', service: 'Chimney Construction', rating: 5, text: 'Our old chimney was falling apart. Valley View rebuilt it from the ground up with gorgeous natural stone. The new chimney is a showpiece — our neighbors keep asking who did it. Excellent work, fair pricing.' },
  { name: 'Thomas K.', location: 'Granger, IN', service: 'Commercial Masonry', rating: 5, text: 'Used Valley View for our restaurant exterior stone facade. They handled everything from permits to final inspection. The building looks incredible and we\'ve had so many new customers say the exterior caught their eye. Truly professional.' },
];

const TestimonialsSection = () => {
  const [active, setActive] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) setVisible(true); }, { threshold: 0.2 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const t = setInterval(() => setActive((p) => (p + 1) % testimonials.length), 6000);
    return () => clearInterval(t);
  }, []);

  const t = testimonials[active];

  return (
    <section ref={ref} className="py-20 md:py-28 bg-brand-cream">
      <div className="max-w-5xl mx-auto px-4 md:px-8 lg:px-12">
        <div className={`text-center mb-12 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="inline-flex items-center gap-2 px-3 py-1.5 border border-brand-amber/40 rounded-full mb-4">
            <span className="text-xs font-semibold text-brand-amber uppercase tracking-widest">Client Stories</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-brand-dark">
            What Michiana <span className="text-brand-amber italic">Homeowners Say</span>
          </h2>
        </div>

        <div className={`bg-white rounded-3xl p-8 md:p-12 border border-brand-cream-dark transition-all duration-700 delay-200 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="flex gap-1 mb-6">
            {Array.from({ length: t.rating }).map((_, i) => (
              <div key={i} className="w-5 h-5 flex items-center justify-center">
                <i className="ri-star-fill text-brand-amber" />
              </div>
            ))}
          </div>
          <blockquote className="font-serif text-xl md:text-2xl text-brand-dark leading-relaxed mb-8 italic">
            &ldquo;{t.text}&rdquo;
          </blockquote>
          <div className="flex items-center justify-between flex-wrap gap-4">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-brand-amber/15 rounded-full">
                <i className="ri-user-line text-brand-amber text-xl" />
              </div>
              <div>
                <p className="font-semibold text-brand-dark">{t.name}</p>
                <p className="text-sm text-brand-stone">{t.location} · {t.service}</p>
              </div>
            </div>
            <div className="flex items-center gap-1.5 px-3 py-1.5 bg-green-50 rounded-full">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-google-fill text-green-600 text-xs" />
              </div>
              <span className="text-xs font-semibold text-green-700">Verified Google Review</span>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 mt-8">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className={`rounded-full transition-all duration-300 cursor-pointer ${i === active ? 'w-8 h-3 bg-brand-amber' : 'w-3 h-3 bg-brand-stone/30 hover:bg-brand-amber/50'}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
